import type { AppState } from '@store/types'

export const selectDashboard = (state: AppState) => state.dashboard
